import * as lib from '~/dependencies';

export const ThumbsContainer = lib.styled.aside`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Thumb = lib.styled.div`
  display: inline-flex;
  border-radius: 2px;
  margin-bottom: 8px;
  margin-right: 8px;
  padding: 4px;
  box-sizing: border-box;
  position: relative;

`;

export const RemoveImageButton = lib.styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #cccccc;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  
  &:hover {
    background-color: #ff6666;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const ThumbInner = lib.styled.div`
  display: flex;
  min-width: 0;
  overflow: hidden;
`;

export const ThumbImage = lib.styled.img`
  display: block;
  width: 100%;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;

export const NonImagePreview = lib.styled.div`
  width: 130px;
  min-height: 50px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 12px;
`;

export const NonImageBadge = lib.styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  background: #e6eef9;
  color: #2e4a73;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  margin-bottom: 8px;
`;

export const NonImageName = lib.styled.span`
  max-width: 100%;
  color: #555;
  font-size: 12px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
